import { useMemo } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { DASHBOARD2_WELCOME_MESSAGE_KEYS } from "../constants/dashboard2-welcome-messages.constants";
import type { DayWorkStatus } from "../types/dashboard2-work-status.types";
import { pickDashboard2WelcomeMessageKey } from "../utils/dashboard2-welcome-messages.utils";

export const useDashboard2WelcomeMessage = (status: DayWorkStatus): string => {
  const { t } = useTranslation();
  const dateKey = DateTime.now().toFormat("yyyy-MM-dd");

  const messageKey = useMemo(
    () => pickDashboard2WelcomeMessageKey(status.kind, dateKey, DASHBOARD2_WELCOME_MESSAGE_KEYS),
    [dateKey, status.kind]
  );

  return messageKey ? t(messageKey) : "";
};
